import React, { useState, useEffect, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import {
  Box,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Typography,
  Paper,
  IconButton,
  Button,
  CircularProgress,
  Backdrop,
  Popover,
  Skeleton,
  Tooltip,
  TextField,
  MenuItem,
  ListItemText,
  Autocomplete,
  useMediaQuery,
  Stack,
  Fade,
} from '@mui/material';
import MUILink from '@mui/material/Link';
import { useLocation } from 'react-router-dom';
import { visuallyHidden } from '@mui/utils';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import {
  ArrowCircleRight,
  Clear,
  CloudDownload,
  CloudUpload,
  Delete,
  Edit,
  EditOff,
  MarkEmailUnread,
  MoreVert,
  Print,
  Share,
} from '@mui/icons-material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import RunningWithErrorsIcon from '@mui/icons-material/RunningWithErrors';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { display } from '../../redux/reducers/sidebar';
import { MoneyFormatv3 } from '../../library/MoneyFormat';
import { API, graphqlOperation } from 'aws-amplify';
import { getPartyAddressEway, getTransactionMaster, listPurchaseMasterCount, listPurchaseMasterTestCustom } from '../../graphql';
import MuiAlert from '@mui/material/Alert';
import DeletePurchaseMaster from '../../components/modals/DeletePurchaseMaster';
import DeleteSelectedPurchaseMaster from '../../components/modals/DeleteSelectedPurchaseMaster';
import { ThreeDot } from '../../components/DropDown/ThreeDot';
import DropDownForListing from '../../components/DropDown/DropDown';
import CancelPurchase from '../../components/modals/CancelPurchase';
import { createDebouncedCallback } from '../../hooks/createDebouncedCallback';
import { useWarningModal } from '../../components/modals/AddUnits';
import { cancelPurchaseMaster } from '../../graphql/mutations';
import { showErrorSnackbar, showSuccessSnackbar, showWarningSnackbar } from '../../components/snackBar/snakbar';
import CustomDate from '../../components/Date/CustomDate.jsx';
import LinkList from '../../components/Buttons/linkList.jsx';
import { updateTitle, updateViewTitle } from '../../redux/reducers/titleSlice.js';
import { ClearIcon } from '@mui/x-date-pickers';
import PeriodDropDown from '../../components/DropDown/PeriodDropDown.jsx';
import MoneyRanger from '../../components/formElements/MoneyRanger.jsx';
import {
  checkandopenpdf,
  defaultRowsPerPage,
  defaultRowsPerPageOptions,
  fetchAndPrintPDF,
  getDefaultSorting,
  handleFreeze,
} from '../../utils/common.js';
import { useThemes } from '../../components/Theme/theme.js';
import { useCreatePdfMutation } from '../../redux/apis/createPdf.api.js';
import dayjs from 'dayjs';
import { LedgerTransactionModalv2 } from '../LedgerTransaction/TransactionsModal.jsx';
import { axiosInstanceForLambda } from '../../library/Axios.js';
import EInvoiceCancel from '../../components/modals/eInvoiceCancel.jsx';
import API_ENDPOINTS from '../../apiEndpoints.js';
import EInvAuth from '../PrimeFigma/Modals/EInvAuth.jsx';
import { einvAuth, einvAuthData, einvId, einvPreview } from '../../redux/reducers/eInvReducer.js';
import { ShareModal } from '../../components/modals/Share.jsx';
import { formatUnixTimestamp, formatDate } from '../../library/dayJs';
import pdfImage from '../../assets/images/attachments/pdf.png';
import { IS_LOCAL } from '../../config.js';
import TableSearchButton from '../PrimeFigma/Components/TableSearchButton.jsx';
import { TableCell } from '../../components/Table/TableCell';
import RollingSoon from '../../components/Ui/RollingSoon';
import { DateRangeRsuite, MoneyTextFieldRange, SimplePeriodDropdown } from '../../components';
import { handleEwaybillValidation } from '../../utils';
import { SendEmailModalWrapper, useSendEmailModal } from '../../features/Email';
import TimeLeftComp from './timeLeftComp';
import { useFetchOpeningBalanceDateQuery } from '../../redux/apis/openingbalacedate.api';

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc' ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);
}

// This method is created for cross-browser compatibility, if you don't
// need to support IE11, you can use Array.prototype.sort() directly

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}
const headCell = [
  {
    id: 'EntryDate',
    numeric: false,
    disablePadding: true,
    label: 'Entry Date',
    width: '100px',
  },
  {
    id: 'VoucherNumber',
    numeric: false,
    disablePadding: false,
    label: 'Voucher No',
    width: '100px',
  },
  {
    id: 'SupplierName',
    numeric: false,
    disablePadding: false,
    label: 'Supplier Name',
    width: '130px',
  },
  {
    id: 'Status',
    numeric: false,
    disablePadding: false,
    label: 'Status',
    width: '100px',
    disableSort: true,
  },
  {
    id: 'dueDate',
    numeric: false,
    disablePadding: false,
    label: 'DueDate',
    width: '100px',
  },
  {
    id: 'GrantTotalAmount',
    numeric: true,
    disablePadding: false,
    label: 'Amount (₹)',
    width: '100px',
  },
  {
    id: 'balancedueamount',
    numeric: true,
    disablePadding: false,
    label: 'Inv. Net Due (₹)',
    width: '100px',
  },
  {
    id: 'overDueDays',
    numeric: true,
    disablePadding: false,
    label: 'Due in/Over Due',
    width: '130px',
  },
  {
    id: 'E-way bill',
    numeric: false,
    disablePadding: false,
    label: 'E way bill',
    width: '100px',
    search: false,
    disableSort: true,
  },
  {
    id: 'Cancel E-way bill',
    numeric: false,
    // disablePadding: true,
    label: '',
    width: '8px',
    search: false,
    disableSort: true,
  },
  // {
  //   id: 'E-way bill status',
  //   numeric: false,
  //   disablePadding: false,
  //   label: 'E-way bill status',
  //   width: '110px',
  //   search: false,
  //   disableSort: true,
  // },
  {
    id: 'SupplierInvoiceDate',
    numeric: false,
    disablePadding: false,
    label: 'Supplier Invoice Date',
    width: '100px',
  },
  {
    id: 'SupplierInvoiceNumber',
    numeric: true,
    disablePadding: false,
    label: 'Supplier Invoice#',
    width: '100px',
  },
  {
    id: 'Action',
    numeric: false,
    disablePadding: false,
    label: 'Actions',
    // disableSort: true,
    width: '100px',
    search: true,
  },
  {
    id: '',
    numeric: false,
    disablePadding: false,
    label: '',
    width: '130px',
    search: false,
    disableSort: true,
  },
  // {
  //   id: "actions",
  //   numeric: false,
  //   disablePadding: false,
  //   label: "Actions",
  //   width: "80px",
  //   disableSort: true,
  // },
];

function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
    onDelete,
    setEnableSearch,
    EnableSearch,
    getCompany,
    rowLength,
    setShowActions,
    showActions,
    scroll,
  } = props;
  const createSortHandler = (event, property) => {
    onRequestSort(event, property);
  };
  const { theme } = useThemes();
  const smalldevices = useMediaQuery('(max-width:480px)');

  function overDueFunction(label) {
    const [beforeSlash, afterSlash] = label.split('/');

    return (
      <span>
        <span style={{ color: 'green' }}>{beforeSlash}/</span>
        <span style={{ color: 'red' }}>{afterSlash}</span>
      </span>
    );
  }

  return (
    <TableHead>
      <TableRow
        sx={{
          backgroundColor: 'background.tablebg',
          '& .MuiTableCell-root': {
            backgroundColor: `${theme.palette.background.tablebg} !important`,
            fontSize: '14px', // Adjust font size as needed
          },
          '.MuiTableCell-head': {
            backgroundColor: 'background.tablebg',
            padding: '2px 6px',
            borderBottom: '0px',
          },
          height: '35px',
        }}
      >
        {/* <TableCell
          padding="checkbox"
          sx={{
            ".css-1mqsplk-MuiButtonBase-root-MuiCheckbox-root": {
              padding: "5px",
            },
          }}
        >
          <Checkbox
            sx={{ color: "input.border" }}
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{
              "aria-label": "select all desserts",
            }}
            size="small"
          />
        </TableCell> */}
        {headCell.map((headCell) => (
          <TableCell
            id={headCell.id === 'Action' ? 'action' : ''}
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{
              display:
                headCell.id == 'E-way bill' || headCell.id == 'Cancel E-way bill'
                  ? getCompany?.relatedcompanydetailsnew?.[0].ewaybillflag == 1
                    ? ''
                    : 'none'
                  : '',
              // minWidth: rowLength > 0 ? headCell.width : "auto",
              // maxWidth: rowLength > 0 ? "auto" : headCell.width,
              position: headCell.id === 'Action' ? 'sticky' : '',
              right: headCell.id === 'Action' ? 0 : '',
              minWidth: headCell.width,
              // padding: headCell.id ==="Cancel E-way bill"&& "0px"

              // borderLeft: headCell.id === "Action" ? "1px solid" : "0px",
            }}
            //  sx={{maxWidth:headCell.width}}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: headCell.id === 'Action' ? 'center' : 'space-between',
                alignItems: 'center',
                flexDirection: headCell.numeric ? 'row-reverse' : '',
                // border: headCell.id === 'Action' ? '1px solid black' : '',
                borderRadius: headCell.id === 'Action' ? '3px' : '',
                width: '100%',
                backgroundColor: headCell.id === 'Action' ? 'white' : 'background.tablebg',
                boxShadow: headCell.id === 'Action' && scroll ? '0px 4px 8px rgba(0, 0, 0, 0.6)' : '',
                '&:active': {
                  transform: scroll ? 'scale(0.92)' : 'scale(1)',
                },
              }}
              onClick={(e) => {
                if (headCell.label === 'Actions') {
                  setShowActions((pre) => !pre);
                }
              }}
            >
              <>
                <TableSortLabel
                  active={orderBy === headCell.id ? true : 'dueDate' === headCell.id && orderBy === 'dueDateTimeStamp' ? true : false}
                  direction={orderBy === 'dueDateTimeStamp' || 'InvoiceDateTimeStamp' ? order : orderBy === headCell.id ? order : 'asc'}
                  onClick={(e) => (headCell.id == 'Action' || headCell.disableSort ? null : createSortHandler(e, headCell.id))}
                  hideSortIcon={headCell.id == 'Action' || headCell.disableSort}
                >
                  <Box sx={{ display: 'flex' }}>
                    <Box sx={{ whiteSpace: 'nowrap' }}>
                      {' '}
                      {headCell.id === 'overDueDays' ? overDueFunction(headCell.label) : headCell.label}
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      {orderBy === headCell.id ? (
                        <Box
                          //  component="span"
                          sx={visuallyHidden}
                        >
                          {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                        </Box>
                      ) : null}

                      {headCell.search === true &&
                        (headCell.id === 'Action' && scroll ? (
                          <ArrowCircleRight
                            sx={{
                              transition: 'transform 0.3s ease-in-out',
                              marginLeft: '10px',
                              transform: !showActions ? 'rotate(180deg)' : 'rotate(0deg)',
                              color: !showActions ? 'gray' : '#ee5b2b',
                            }}
                            fontSize="small"
                          />
                        ) : // <SearchIcon
                        //   onClick={(e) => {
                        //     e.preventDefault();
                        //     e.stopPropagation();
                        //     setEnableSearch((prev) => !prev);
                        //   }}
                        //   sx={{ marginLeft: "10px" }}
                        //   fontSize="small"
                        // />
                        null)}
                    </Box>
                  </Box>
                </TableSortLabel>
              </>
            </Box>
          </TableCell>
        ))}
        {numSelected > 0 ? (
          <TableCell>
            <ThreeDot
              onDelete={() => {
                onDelete(true);
              }}
            />
          </TableCell>
        ) : null}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function AllPurchaseandExpense() {
  const { theme } = useThemes();

  const device = useMediaQuery(theme.breakpoints.down('sm'));

  const dispatch = useDispatch();
  dispatch(display());
  const location = useLocation();
  const [firstMount, setfirstMount] = useState({ current: true });
  const debouncedSearchRef = useRef(null);

  useEffect(() => {
    const controlAndS = (e) => {
      if (e.ctrlKey && e.key.toLowerCase() === 's') {
        e.preventDefault();
        // showErrorSnackbar("Nothing to save");
      }
    };

    window.addEventListener('keydown', controlAndS);

    return () => {
      window.removeEventListener('keydown', controlAndS);
    };
  }, []);
  useEffect(() => {
    if (firstMount.current) {
      setfirstMount({ current: false });
    }
  }, []);
  const navigate = useNavigate();
  const { defaultSortingColumn, defaultSortingOrder } = getDefaultSorting('purchase');
  const [order, setOrder] = useState(defaultSortingOrder);
  const [orderBy, setOrderBy] = useState(defaultSortingColumn);
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [action, setAction] = useState('');
  const [actionData, setActionData] = useState({});
  const [dense, setDense] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(defaultRowsPerPage);
  // Store latest values in refs to avoid stale closures
  const rowsPerPageRef = useRef(rowsPerPage);
  rowsPerPageRef.current = rowsPerPage;
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [deleteModalStatus, setDeleteModalStatus] = useState(false);
  const [cancelModalStatus, setCancelModalStatus] = useState(false);
  const [dataCount, setdataCount] = useState(0);
  const [rows, setRows] = useState([]);
  const [deleteId, setDeleteId] = useState('');
  const [circularOpen, setCircularOpen] = useState(true);
  const [itemData, setItemData] = useState({});
  const [deleteSelectedModal, setDeleteSelectedModal] = useState(false);
  const [companyDetails, setCOmpanyDetails] = useState([]);
  const [cancelEOpen, setCancelEOpen] = useState(false);
  const [rowData, setRowData] = useState({});
  const [connectCheckbox, setConnectCheckbox] = useState('');
  const defaultFilterColumns = {
    entryDate: '',
    VoucherNumber: '',
    supplierInvoiceDate: '',
    SupplierInvoiceNumber: '',
    SupplierName: '',
    SupplierID: '',
    Status: '',
    dueDate: '',
    DueDateFrom: '',
    DueDateTo: '',
    GrantTotalAmount: '',
    AmountFrom: '',
    AmountTo: '',
    BalanceDueAmount: '',
    balancedueamountfrom: '',
    balancedueamountto: '',
    overDueDays: '',
    CancelFlag: '',
    EntryDateFrom: '',
    EntryDateTo: '',
    SupplierInvoiceDateFrom: '',
    SupplierInvoiceDateTo: '',
  };
  const [filterColumns, setFilterColumns] = useState(defaultFilterColumns);
  const handleResetFilterColumns = (status) => (status === false ? setFilterColumns(defaultFilterColumns) : null);
  const filterColumnsRef = useRef(filterColumns);
  filterColumnsRef.current = filterColumns;
  const [gstStatus, setGstStatus] = useState('');
  const [disableToolTip, setdisableToolTip] = useState(false);
  const [exportStartDate, setExportStartDate] = useState('');
  const [cancelEInv, setCancelEInv] = useState(false);
  const [cancelEInvState, setCancelEInvState] = useState({
    reason: '',
    remark: '',
    errorStatus: {
      reason: false,
      remark: false,
    },
  });
  let userPreferece = useSelector((state) => state.userPrefrenceandReducer);
  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });
  let { WarningModal, handleOpen: setWarningOpen } = useWarningModal();
  const [state, setState] = useState({
    reason: '',
    errorFields: {
      reason: '',
    },
    errorStatus: {
      reason: false,
    },
  });
  const [exportItem, setExportItem] = useState(null);
  const [exportModalOpen, setExportModalOpen] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  // Click handler for the main box to open the popover
  const handleClickBox = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  const { data: openingBalanceDate, isLoading } = useFetchOpeningBalanceDateQuery(
    {
      invoicetypecd: 'Sales',
      invoiceid: 0,
    },
    {
      refetchOnMountOrArgChange: true,
    }
  );
  // Click handler to close the popover
  const obDate = dayjs(openingBalanceDate?.getMinMaxInvoiceDate?.openingbalancedate).unix();
  useEffect(() => {
    if (startDate > obDate) {
      setExportStartDate(startDate);
    } else {
      setExportStartDate(obDate);
    }
  }, [obDate, startDate]);
  useEffect(() => {
    if (filterColumns.InvoiceDateFrom && filterColumns.InvoiceDateTo) {
      setStartDate(filterColumns.InvoiceDateFrom);
      setEndDate(filterColumns.InvoiceDateTo);
    } else {
      setStartDate(userPreferece?.financialYear?.startdate);
      setEndDate(userPreferece?.financialYear?.enddate);
    }
  }, [filterColumns, userPreferece]);
  const handleClose = () => {
    setAnchorEl(null);
  };

  const getCompany = useSelector((state) => state?.companyReducer.companyDetails);
  // Check if the popover should be open based on anchorEl
  const open = Boolean(anchorEl);

  // Options to display in the popover, each with a label and onClick handler
  const options = [
    // {
    //   label: 'Import',
    //   icon: <CloudDownload sx={{ color: 'blue' }} />,
    //   onClick: () => {},
    //   link: '/import-data',
    // },
    // {
    //   label: 'Export',
    //   icon: <CloudUpload sx={{ color: '#ffa500' }} />,
    //   onClick: () => {
    //     if (rows.length > 0) {
    //       setExportModalOpen(true);
    //       setExportItem('PURCHASE');
    //     } else {
    //       showWarningSnackbar('No data available for export.');
    //     }
    //   },
    //   link: '',
    //   rollingOutSoon: true,
    // },
    {
      label: 'Export',
      icon: <CloudUpload sx={{ color: '#ffa500' }} />,
      onClick: () => {
        // if (invoiceRows.length > 0) {
        //   setExportModalOpen(true);
        //   setExportItem('INVOICE');
        // } else {
        //   showWarningSnackbar('No data available for export.');
        // }
        // const to = `/exports/sales?startDate=${startDate}&endDate=${endDate}`
        // navigate('/');
      },
      link: `/exports/purchase?startDate=${exportStartDate}&endDate=${endDate}`,
      rollingOutSoon: true,
    },
    {
      label: 'Send Selected Invoices',
      icon: <MarkEmailUnread />,
      onClick: () => {
        handleBulkEmail();
      },
      link: '',
    },
  ];

  const handleRequestSort = (event, property) => {
    let isAsc = orderBy === property && order === 'asc';
    if (property === 'dueDate') {
      isAsc = order === 'asc' ? true : false;
      setOrderBy('dueDateTimeStamp');
    } else {
      setOrderBy(property);
    }
    setOrder(isAsc ? 'desc' : 'asc');
  };

  const handleSelectAllClick = (event) => {
    const isChecked = event.target.checked;
    if (isChecked && rows.length) {
      const newSelected = rows.map((n) => ({
        Email: n?.partyemail,
        partyaccountid: n?.partyaccountid,
        PartyDisplayName: n?.partyname,
        PartyID: n?.supplierid,
        partytypecd: n?.partytypecd,
        invoiceid: n?.purchaseid,
        invoicenumber: n?.vouchernumber,
      }));
      setSelected(newSelected);
      setEmailSendingSelection(newSelected);
      return;
    }
    setSelected([]);
    setEmailSendingSelection([]);
  };

  const handleClick = (event, row) => {
    const selectedIndex = selected.findIndex((item) => item.invoiceid === row.purchaseid);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, {
        Email: row?.partyemail,
        partyaccountid: row?.partyaccountid,
        PartyDisplayName: row?.partyname,
        PartyID: row?.supplierid,
        partytypecd: row?.partytypecd,
        invoiceid: row?.purchaseid,
        invoicenumber: row?.vouchernumber,
      });
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
    setEmailSendingSelection(newSelected);

    // if (selectedIndex === -1) {
    //   newSelected = newSelected.concat(selected, name);
    // } else if (selectedIndex === 0) {
    //   newSelected = newSelected.concat(selected.slice(1));
    // } else if (selectedIndex === selected.length - 1) {
    //   newSelected = newSelected.concat(selected.slice(0, -1));
    // } else if (selectedIndex > 0) {
    //   newSelected = newSelected.concat(
    //     selected.slice(0, selectedIndex),
    //     selected.slice(selectedIndex + 1)
    //   );
    // }
  };

  const [ListSelection, setListSelection] = useState('All');

  const handleChangePage = (event, newPage) => {
    if (circularOpen) return;
    if (newPage > page) {
      if (rows.length !== dataCount)
        if (rows.length < rowsPerPageRef.current * (newPage + 1)) {
          listPurchaseandExpense(false, rows.length, Math.abs(rowsPerPageRef.current * (newPage + 1) - rows.length));
        }
    }
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    if (circularOpen) return;

    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (invoiceId) => selected.some((item) => item.invoiceid === invoiceId);
  let search = (obj) => {
    listPurchaseandExpense(true, 0, rowsPerPageRef.current, obj);
  };

  if (!debouncedSearchRef.current) {
    debouncedSearchRef.current = createDebouncedCallback(
      (obj) => {
        // Always use current values from refs
        const currentFilterColumns = filterColumnsRef.current;
        const currentRowsPerPage = rowsPerPageRef.current;

        // Check if there are any non-empty filter values
        const hasFilters = Object.values(currentFilterColumns).some((value) => value && value.toString().trim().length > 0);

        if (hasFilters) {
          listPurchaseandExpense(true, 0, currentRowsPerPage, currentFilterColumns);
        } else {
          listPurchaseandExpense(true, 0, currentRowsPerPage);
        }
      },
      500,
      false
    );
  }

  const filterSearch = useCallback((obj) => {
    debouncedSearchRef.current(obj);
  }, []);
  useEffect(() => {
    if (firstMount.current === false) {
      // Use the debounced search which will check current filterColumns
      filterSearch();
    }
    return () => {};
  }, [filterColumns, filterSearch]);
  const eWayValidate = async () => {
    const payload = {
      action: 'authenticate',
    };
    setBackdropOpen(true);
    try {
      const res = await axiosInstanceForLambda.post(API_ENDPOINTS.REACT_APP_EWAYBILL_URL, payload);
      console.log(res.data, 'data');
      return res.data;
    } catch (error) {
      console.log(error, 'Error');
      const rawMessage = error?.response.data.error;
      console.log(rawMessage, 'rawMessage');
      const parsedMessage = JSON.parse(rawMessage);
      console.log(parsedMessage, 'parsedMessage');
      const errorMessage = parsedMessage.ErrorDetails[0].ErrorMessage;
      showWarningSnackbar(errorMessage);
      setCancelEOpen(true);
    } finally {
      setBackdropOpen(false);
    }
  };
  let handleInputChange = useCallback((name, value) => {
    // const { name, value } = e.target;

    let errorStatus = value ? false : true;

    setCancelEInvState((prevState) => {
      return {
        ...prevState,
        [name]: value,
        // errorFields: {
        //     ...prevState.errorFields,
        //     reason: newReason.length < 5 ? 'Reason is too short' : ''
        // },
        errorStatus: {
          ...prevState.errorStatus,
          [name]: errorStatus,
        },
      };
    });
  }, []);
  const handleEINVBlur = (name) => {
    if (name === 'remark') {
      setCancelEInvState((prevState) => ({
        ...prevState,
        errorStatus: {
          ...prevState.errorStatus,
          [name]: cancelEInvState[name]?.trim() === '',
        },
      }));
    } else {
      setCancelEInvState((prevState) => ({
        ...prevState,
        errorStatus: {
          ...prevState.errorStatus,
          [name]: cancelEInvState[name] === '',
        },
      }));
    }
  };

  const handleFilterBySearch = (event, category, value) => {
    setPage(0);
    let query = value ? value : event.target?.value;
    let name = category;
    const obj = { ...filterColumnsRef.current };

    if (name === 'GrandTotalAmount') {
      obj['AmountFrom'] = query[0];
      obj['AmountTo'] = query[1];
    } else if (name === 'BalanceDueAmount') {
      obj['balancedueamountfrom'] = query[0];
      obj['balancedueamountto'] = query[1];
    } else {
      for (const key in obj) {
        if (key == name) {
          obj[key] = query;
        } else {
          // obj[key] = "";
        }
      }
    }
    setFilterColumns(obj);
  };

  // useEffect(() => {
  //   setFilteredList(rows);
  //   // console.log(Object.keys(rows[0]))
  // }, [rows]);

  useEffect(() => {
    if (firstMount.current === false) {
      if (rowsPerPageRef.current > rows.length) {
        listPurchaseandExpense(true, 0, rowsPerPageRef.current);
      } else {
      }
    }
    return () => {};
  }, [rowsPerPage]);

  useEffect(() => {
    setRows([]);
    setPage(0);
    listPurchaseandExpense(true, 0, rowsPerPageRef.current);
    return () => {};
  }, [order, orderBy]);
  const [limit, setlimit] = useState(rowsPerPageRef.current);
  const [filterColumnsMaxValues, setfilterColumnsMaxValues] = useState({
    GrantTotalAmount: 0,
    BalanceDueAmount: 1000000,
  });
  useEffect(() => {
    API.graphql(
      graphqlOperation(listPurchaseMasterTestCustom, {
        rowfrom: 0,
        limitno: 1,
        columnname: 'GrantTotalAmount',
        ordertype: 'DESC',
        searchmode: 0,
        searcharray: JSON.stringify([]),
      })
    ).then((res) => {
      console.log(res);
      setfilterColumnsMaxValues((prev) => ({
        ...prev,
        GrantTotalAmount: res?.data?.listPurchaseMasterTest?.[0]?.granttotalamount,
      }));
    });
    return () => {};
  }, []);
  const [dataLoader, setDataLoader] = useState(true);
  async function listPurchaseandExpense(reset, from, to, filterColumn) {
    try {
      setCircularOpen(true);
      if (rows.length / rowsPerPageRef.current == page + 1) {
        setlimit(to);
      } else if (rows.length / rowsPerPageRef.current < 1) {
        setlimit(rowsPerPageRef.current - rows.length);
      }
      setCircularOpen(true);
      if (reset) {
        setRows([]);
        setPage(0);
      }
      let searchMode = 0;
      let SearchArray = [];
      filterColumn = filterColumn ? filterColumn : filterColumnsRef.current;
      // Handle AmountFrom and AmountTo together to avoid duplicates
      const amountFrom = filterColumn.AmountFrom || '';
      const amountTo = filterColumn.AmountTo || '';

      if (amountFrom || amountTo) {
        searchMode = 1;
        // Ensure From < To before adding to SearchArray
        const lowerAmount = Number(amountFrom < amountTo ? amountFrom : amountTo);
        const higherAmount = Number(amountFrom < amountTo ? amountTo : amountFrom);

        // Add both values with correct order
        SearchArray = [...SearchArray, { AmountFrom: lowerAmount }, { AmountTo: higherAmount }];
      } else if (amountFrom) {
        searchMode = 1;
        SearchArray = [...SearchArray, { AmountFrom: amountFrom }];
      } else if (amountTo) {
        searchMode = 1;
        SearchArray = [...SearchArray, { AmountTo: amountTo }];
      }

      // Handle BalanceDueAmountFrom and BalanceDueAmountTo together to avoid duplicates
      const balanceDueAmountFrom = filterColumn.balancedueamountfrom || '';
      const balanceDueAmountTo = filterColumn.balancedueamountto || '';

      if (balanceDueAmountFrom || balanceDueAmountTo) {
        searchMode = 1;
        // Ensure From < To before adding to SearchArray
        const lowerBalanceDueAmount = Number(balanceDueAmountFrom < balanceDueAmountTo ? balanceDueAmountFrom : balanceDueAmountTo);
        const higherBalanceDueAmount = Number(balanceDueAmountFrom < balanceDueAmountTo ? balanceDueAmountTo : balanceDueAmountFrom);

        // Add both values with correct order
        SearchArray = [...SearchArray, { balancedueamountfrom: lowerBalanceDueAmount }, { balancedueamountto: higherBalanceDueAmount }];
      } else if (balanceDueAmountFrom) {
        searchMode = 1;
        SearchArray = [...SearchArray, { balancedueamountfrom: balanceDueAmountFrom }];
      } else if (balanceDueAmountTo) {
        searchMode = 1;
        SearchArray = [...SearchArray, { balancedueamountto: balanceDueAmountTo }];
      }

      Object.keys(filterColumn).map((key) => {
        if (filterColumn[key]?.toString()?.length > 0) {
          // Skip AmountFrom, AmountTo, balancedueamountfrom, and balancedueamountto as they are handled above
          if (key !== 'AmountFrom' && key !== 'AmountTo' && key !== 'balancedueamountfrom' && key !== 'balancedueamountto') {
            searchMode = 1;
            SearchArray = [...SearchArray, { [key]: filterColumn[key] }];
          }
        }
      });
      // switch (ListSelection) {
      //   case "Active":
      //     SearchArray = [...SearchArray, { CancelFlag: 0 }]
      //     break
      //   case "Cancelled":
      //     SearchArray = [...SearchArray, { CancelFlag: 1 }]
      //     break
      //   default:
      //     break
      // }
      // const resDeleted = API.graphql(graphqlOperation(listDeletedPurchases));

      const resActive = API.graphql(
        graphqlOperation(listPurchaseMasterTestCustom, {
          rowfrom: from,
          limitno: to,
          columnname: orderBy,
          ordertype: order.toUpperCase(),
          searchmode: searchMode,
          searcharray: JSON.stringify(SearchArray),
        })
      );
      const resCount = API.graphql(
        graphqlOperation(listPurchaseMasterCount, {
          columnname: orderBy,
          ordertype: order.toUpperCase(),
          searchmode: searchMode,
          searcharray: JSON.stringify(SearchArray),
        })
      );
      Promise.allSettled([resActive, resCount])
        .then((response) => {
          let res = response[0].value;
          let responseCount = response[1].value;
          setdataCount(
            responseCount.data?.listPurchaseMasterCount?.[0]?.statuscode == null
              ? parseInt(responseCount?.data?.listPurchaseMasterCount?.[0].purchasemasterlistcount)
              : 0
          );
          let arr = [];
          let arrD = [];
          if (res.data.listPurchaseMasterTest != null) {
            arr = res.data.listPurchaseMasterTest.filter((elem) => elem.statuscode == null);
            let type = '';
            arr.map((item) => {
              let from = new Date(Number(item.entrydate) * 1000);
              let frommm = from.getMonth() + 1;
              let fromdd = from.getDate();

              if (fromdd < 10) fromdd = '0' + fromdd;
              if (frommm < 10) frommm = '0' + frommm;
              console.log(item, 'dueDate');
              item.dueDate = formatUnixTimestamp(item.duedatetimestamp);
              item.statuscd = item.balancedueamount === 0 ? 'Paid' : item.balancedueamount !== item.granttotalamount ? 'Partial' : 'UnPaid';
              console.log(item.statuscd);
              item.customerorsupplierid = item.partyid;
              item.customerorsuppliertype = type;
            });
          }

          let cArr = [...arr, ...arrD];
          if (reset) {
            setRows((prev) => [...cArr]);
            setCircularOpen(false);
          } else {
            setRows((prev) => [...prev, ...cArr]);
            setCircularOpen(false);
          }
        })
        .catch((error) => console.log(error))
        .finally(() => {
          setlimit(0);
          setCircularOpen(false);
        });
    } catch (error) {
      setCircularOpen(false);
      setlimit(0);
      console.log(error);
    }
  }
  const ewayNav = (data) => {
    console.log(data, 'datadata');
    navigate('/addewaybill', {
      state: {
        invoice: {
          docDate: formatUnixTimestamp(data.entrydate),
          id: data.purchaseid,
          invoiceNo: data.vouchernumber,
          // irn: data.irn,
          placeofsupply: data.placeofsupply,
          supply: 'I',
          partyId: data.supplierid,
          invoiceType: 'PurchaseInvoice',
        },
        connect: 'invoice',
        from: '/allpurchaseandexpense',
        saveNew: false,
      },
    });
  };
  useEffect(() => {
    setCircularOpen(true);
  }, []);
  // const handleEWaybill = (e, data) => {
  //   setAction('geneway');
  //   e.stopPropagation();
  //   const invoiceDate = moment(new Date(data.entrydate) * 1000).format('DD-MM-YYYY');
  //   console.log(data, 'data11111');
  //   console.log(invoiceDate, 'invoiceDate');

  //   navigate('/addewaybill', {
  //     state: {
  //       invoice: {
  //         docDate: invoiceDate,
  //         id: data.purchaseid,
  //         invoiceNo: data.vouchernumber,
  //         irn: data.irn,
  //         placeofsupply: data.placeofsupply,
  //         supply: 'I',
  //         invoiceType: 'PurchaseInvoice',
  //         partyId: data.supplierid,
  //       },
  //       from: location.pathname,
  //     },
  //   });
  // };
  const companyLoaded = useSelector((state) => state?.companyReducer.Loaded);
  async function getCompanyDetails() {
    try {
      setGstStatus(getCompany?.relatedCompanyDetailsNew?.[0].RegistrationType);
      setCOmpanyDetails({ getCompany });
    } catch (error) {
      console.log('error', error);
    }
  }

  // const handleCancelEWay = async (row) => {
  //   console.log(row, 'row');
  //   debugger;
  //   if (getCompany.relatedcompanydetailsnew[0].ewaybillconnect == 0) {
  //     setCancelEOpen(true);
  //     // const test = await eWayValidate();
  //     // console.log(test, 'test');
  //     // if (test === 'success') {
  //     //   setCancelEInv(true);
  //     // }
  //     // else {
  //     //   setCancelEOpen(true);
  //     // }
  //   } else {
  //     setCancelEInv(true);
  //   }
  //   setRowData({
  //     id: row.purchaseid,
  //     nav: '/allpurchaseandexpense',
  //     todo: 'cancel',
  //     irn: row.irn,
  //     billno: row.ewaybillno,
  //     from: 'E-Way',
  //   });
  // };
  // console.log(rowData, 'rowdata');
  // const handleCancelEWaybill = async () => {
  //   const payload = {
  //     action: 'CANEWB',
  //     // credentials: {
  //     //   userName: 'AL001',
  //     //   password: 'Alankit@123',
  //     // },
  //     data: {
  //       ewbNo: rowData.billno,
  //       cancelRsnCode: cancelEInvState.reason,
  //       cancelRmrk: cancelEInvState.remark,
  //     },
  //   };
  //   setBackdropOpen(true);
  //   try {
  //     const res = await axiosInstanceForLambda.post(API_ENDPOINTS.REACT_APP_EWAYBILL_URL, payload);
  //     console.log(res, 'ressssss');
  //     showSuccessSnackbar('E way bill successfully cancelled');
  //     setRows((currentItems) => {
  //       console.log(currentItems, 'currentItems');
  //       return currentItems.map((item) => (item.purchaseid === rowData.id ? { ...item, ewaybill_is_cancelled: 1 } : { ...item }));
  //     });
  //     setCancelEInv(false);
  //     if (getCompany.relatedcompanydetailsnew[0].einvoiceconnect == 0) {
  //       dispatch(
  //         einvAuthData({
  //           userName: '',
  //           password: '',
  //         })
  //       );
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   } finally {
  //     setBackdropOpen(false);
  //   }
  // };
  const handleEWaybill = async (e, data) => {
    console.log(data, 'data');
    setAction('geneway');
    e.stopPropagation();
    setConnectCheckbox('eway');
    const resPartyAddressEntityDetails = await API.graphql(
      graphqlOperation(getPartyAddressEway, {
        objectid: data.purchaseid,
        objecttype1: 'PurchaseBilling',
        objecttype2: 'PurchaseDelivery',
      })
    );
    console.log(resPartyAddressEntityDetails, 'resPartyAddressEntityDetails');
    // Use utility function for E-way bill validation
    const isValidEway = handleEwaybillValidation(resPartyAddressEntityDetails, showWarningSnackbar, setBackdropOpen);

    if (!isValidEway) {
      return;
    }
    if (getCompany.relatedcompanydetailsnew[0].ewaybillconnect == 1) {
      // const test = await eWayValidate();
      // if (test === 'success') {
      ewayNav(data);
      // } else {
      //   setCancelEOpen(true);
      // }
    } else {
      setCancelEOpen(true);
    }
  };

  const handleCancelEWay = async (row) => {
    setConnectCheckbox('eway');
    setAction('caneway');
    if (getCompany.relatedcompanydetailsnew[0].ewaybillconnect == 1) {
      // const test = await eWayValidate();
      // if (test === 'success') {
      setCancelEInv(true);
      // } else {
      //   setCancelEOpen(true);
      // }
    } else {
      setCancelEOpen(true);
    }
    setRowData({
      id: row.purchaseid,
      nav: '/salesInvoiceReport',
      todo: 'cancel',
      // irn: row.irn,
      billno: row.ewaybillno,
      from: 'E-Way',
    });
  };
  let prevData = useSelector((state) => state.eInvReducer.data);
  const handleCancelEWaybill = async () => {
    // e.stopPropagation();
    const payload = {
      action: 'CANEWB',
      // credentials: {
      //   userName: 'AL001',
      //   password: 'Alankit@123',
      // Gstin: '07AGAPA5363L002',
      // userName: "Matrix2050",
      // password: "Matrix@2050",
      // Gstin: "33AAHCS2907G1ZK",
      // },
      data: {
        ewbNo: rowData.billno,
        cancelRsnCode: cancelEInvState.reason,
        cancelRmrk: cancelEInvState.remark,
      },
      ...(Object.keys(prevData).length > 0 ? { credentials: prevData } : null),
    };
    setBackdropOpen(true);
    try {
      const res = await axiosInstanceForLambda.post(API_ENDPOINTS.REACT_APP_EWAYBILL_URL, payload);
      console.log(res, 'res');
      showSuccessSnackbar('E way bill successfully cancelled');
      setRows((currentItems) => {
        return currentItems.map((item) => (item.purchaseid === rowData.id ? { ...item, ewaybill_is_cancelled: 1 } : { ...item }));
      });
      setCancelEInv(false);
      setCancelEInvState({
        reason: '',
        remark: '',
        errorStatus: {
          reason: false,
          remark: false,
        },
      });
      // if (getCompany.relatedcompanydetailsnew[0].einvoiceconnect == 0 || getCompany.relatedcompanydetailsnew[0].ewaybillconnect == 0) {
      // dispatch(
      //   einvAuthData({
      //     userName: '',
      //     password: '',
      //   })
      // );
      // }
    } catch (err) {
      console.log(err);
    } finally {
      setBackdropOpen(false);
      dispatch(einvAuthData({}));
      dispatch(einvAuth(false));
      dispatch(einvPreview({ preview: false, id: 0 }));
      dispatch(einvId(false));
    }
  };
  useEffect(() => {
    getCompanyDetails();
  }, [companyLoaded]);

  const userPrefrenceandReducer = useSelector((state) => state.userPrefrenceandReducer);
  useEffect(() => {
    if (userPrefrenceandReducer?.financialYear) {
      setLedgerModalStartDate(userPrefrenceandReducer?.financialYear?.StartDate);
      setLedgerModalEndDate(userPrefrenceandReducer?.financialYear?.EndDate);
    }
  }, [userPrefrenceandReducer]);

  //New Changes

  const [ledgerModalStartDate, setLedgerModalStartDate] = useState(0);
  const [ledgerModalEndDate, setLedgerModalEndDate] = useState(0);
  const [modalData, setModalData] = useState([]);
  const [allModalData, setAllModalData] = useState([]);
  const [modalTableLength, setModalTableLength] = useState(0);
  const [accountName, setAccountName] = useState('');
  const [accountID, setAccountID] = useState('');
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [showActions, setShowActions] = useState(true);

  // Email sending states
  const [emailSendingSelection, setEmailSendingSelection] = useState([]);
  const [individualEmailSelection, setIndividualEmailSelection] = useState([]);
  const [shareOpen, setShareOpen] = useState(false);

  // Email modal hook
  const { openModal, modalProps } = useSendEmailModal(['purchaseInvoice', 'customer', 'supplier']);

  const handleBulkEmail = () => {
    if (Freeze === 1) {
      return handleFreeze();
    }
    if (emailSendingSelection.length > 0) {
      openModal(
        'purchaseInvoice',
        emailSendingSelection.map((inv) => ({
          id: Number(inv.invoiceid),
          recipientId: Number(inv.PartyID),
          email: inv.Email,
          name: inv.PartyDisplayName,
          invoiceNumber: inv.invoicenumber,
        }))
      );
    } else {
      showWarningSnackbar("No Invoice's selected. Please select at least one Invoice to send the email.");
    }
    setShareOpen(false);
  };

  // Function to explicitly clear email selection
  const clearEmailSelection = () => {
    setEmailSendingSelection([]);
    setIndividualEmailSelection([]);
  };

  const getTransactiondata = (array) => {
    return new Promise((resolve) => {
      let ids = [];
      const items = [];
      array?.map(async (ele) => {
        if (!ids?.includes(ele?.TransactionID)) {
          ids.push(ele?.TransactionID);
          const resTransactionDetails = await API.graphql(
            graphqlOperation(getTransactionMaster, {
              TransactionID: ele?.TransactionID,
            })
          );
          items?.push({
            id: resTransactionDetails.data.getTransactionMaster?.TransactionID,
            typeCD: resTransactionDetails.data.getTransactionMaster.TransactionTypeCD,
            Vno: resTransactionDetails.data.getTransactionMaster.VoucherNumber,
          });
        }
      });

      setTimeout(() => {
        resolve(items);
      }, 2000);
    });
  };
  const cancelInvoice = async (data) => {
    try {
      let payload = {
        InvoiceID: data.InvoiceID,
        CancelFlag: data.CancelFlag == 0 ? 1 : 0,
      };
      setCancelModalStatus(true);
      // let res = await API.graphql(graphqlOperation(cancelInvoiceMaster, { updateInvoicemasterInput: payload }))
    } catch (error) {
      console.log(error);
    }
  };
  // New Changes
  async function cancel(data) {
    try {
      let payload = {
        PurchaseID: data.id,
        CancelFlag: data.CancelFlag == 0 ? 1 : 0,
        CancelRemark: state?.reason,
      };
      const res = await API.graphql(
        graphqlOperation(cancelPurchaseMaster, {
          updatePurchaseMasterInput: payload,
        })
      );
      // listPurchaseandExpense(true,)
      // if (res.data?.deleteInvoiceMaster != null) {
      //     let arr = rows.filter((item, ind) => {
      //         if (ind != itemData?.ind) {
      //             return item
      //         }
      //     })
      //     setRows(arr)
      // listInvoices()
      // setState({
      //   reason: "",
      //   errorStatus: {
      //     reason: false,
      //   },
      //   errorFields: {
      //     reason: "",
      //   }
      // })
      showSuccessSnackbar('Purchase Cancelled!');
    } catch (error) {
      // setLoading(false)
      console.log(error);
    }
  }

  function overDue(day) {
    if (/^\d{2}-\d{2}-\d{4}$/.test(day)) {
      const [dd, mm, yyyy] = day.split('-');
      day = `${yyyy}-${mm}-${dd}`;
    }

    const targetDate = new Date(day);
    const currentDate = new Date();

    const diffTime = targetDate.getTime() - currentDate.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  }
  const handleRowClick = (row) => {
    // dispatch(updateTitle(row.CancelFlag == 1 ? JSON.stringify({ type: "Cancelled", name: row.VoucherNumber }) :
    //   JSON.stringify({ type: "", name: row.VoucherNumber })));
    // dispatch(updateViewTitle(row.CancelFlag == 1 ? { type: 'Cancelled', name: row.vouchernumber } : { type: '', name: row.vouchernumber }));
    dispatch(updateTitle(row.vouchernumber));
    if (row.purchasegsttypecd === 'NONTAXABLE') {
      navigate('/viewpurchaseandexpensenontaxable', {
        state: {
          id: row.purchaseid,
          view: true,
          pdflink: row?.purchaseinvoicepdf,
        },
      });
    } else {
      navigate('/viewnewpurchasetax', {
        state: {
          id: row.purchaseid,
          view: true,
          pdflink: row?.purchaseinvoicepdf,
        },
      });
    }
  };
  const isLocal = IS_LOCAL == 'true';
  const TableCellWithToolTip = ({ align, id, scope, row, sx, padding, children, onClick = () => {} }) => (
    <TableCell style={{ whiteSpace: 'nowrap' }} padding={padding} sx={sx} id={id} align={align} scope={scope} onClick={() => onClick()}>
      <Tooltip followCursor title={row.cancelflag === 1 ? 'Cancelled' : ''} placement="top">
        <Box>{children}</Box>
      </Tooltip>
    </TableCell>
  );
  const [EnableSearch, setEnableSearch] = useState(false);
  const DateRangeRef = useRef(null);
  const openDateRange = () => {
    setEnableSearch(true);
    let response = DateRangeRef?.current?.openDatePicker();
    console.log(response);
  };
  const [SummaryData, setSummaryData] = useState({
    open: false,
    description: '',
    vouchers: [],
  });
  const Freeze = useSelector((state) => state.userPrefrenceandReducer?.financialYear?.freezestatus);

  let path = `${userPreferece?.financialYear?.companyid}/${userPreferece?.financialYear?.companybranchid}/${userPreferece?.financialYear?.financialyearid}/`;

  const [create, progress] = useCreatePdfMutation();
  console.log({ progress });
  const generatePDF = async (invoicenumber, invoiceid) => {
    const response = await create({
      path: 'test20.pdf',
      invoiceids: invoiceid,
      type: 'purchaseInvoice',
    });
    console.log(response);
  };
  const [rolling, setRolling] = useState(false);

  const [scroll, setScroll] = useState(false);
  useEffect(() => {
    if (rows.length > 0 && !circularOpen) {
      const width = pusrchaseTableRef.current?.offsetWidth;
      const screenWidth = window.innerWidth;
      if (width < screenWidth) {
        setScroll(false);
      } else {
        setScroll(true);
      }
    }
  }, [rows, circularOpen]);
  // const generatePDF = async (invoicenumber, invoiceid) => {
  //   let url = path + `Purchase/Ledgerx_Purchase_Invoice${invoicenumber}.pdf`;
  //   await createPDF(
  //     url,
  //     userPreferece?.financialYear?.companyid,
  //     "purchaseInvoice",
  //     invoiceid
  //   );
  // }
  const tableRef = useRef(null);
  const pusrchaseTableRef = useRef(null);

  return (
    <Box className="noTableCellBorder">
      <DeletePurchaseMaster
        open={deleteModalStatus}
        storage={'purchase&expenses'}
        itemId={deleteId}
        setOpen={setDeleteModalStatus}
        itemData={itemData}
        rows={rows}
        setRows={setRows}
        listPurchaseandExpense={listPurchaseandExpense}
      />
      <CancelPurchase
        listPurchaseandExpense={listPurchaseandExpense}
        open={cancelModalStatus}
        setOpen={setCancelModalStatus}
        itemData={itemData}
        rows={rows}
        setRows={setRows}
      />

      <DeleteSelectedPurchaseMaster
        open={deleteSelectedModal}
        setOpen={setDeleteSelectedModal}
        itemsData={selected}
        setSelected={setSelected}
        setSummaryData={setSummaryData}
        rows={rows}
        listPurchaseandExpense={listPurchaseandExpense}
        setRows={setRows}
      />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderTopRightRadius: '12px',
          borderTopLeftRadius: '12px',
          padding: '8px 10px',
          backgroundColor: 'primary.main',
        }}
      >
        <LinkList list="All Purchases" link="/addnewpurchasetax" add="Add Purchase" name="purchase" />

        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <TableSearchButton
            setEnableSearch={setEnableSearch}
            EnableSearch={EnableSearch}
            id={'purchaseSearch'}
            onClick={handleResetFilterColumns}
          />

          <Box
            sx={{
              display: {
                xs: 'none',
                sm: 'flex',
                md: 'flex',
                lg: 'flex',
                xl: 'flex',
                gap: '10px',
              },
            }}
          >
            <Typography
              sx={{
                display: 'flex',
                alignItems: 'center',
                fontSize: { md: '13px', sm: '12px' },
                color: 'white',
                whiteSpace: 'nowrap',
              }}
            >
              Total : {dataCount} Item{dataCount !== 0 && 's'}{' '}
              {selected.length != 0
                ? `(Selected: ${selected.length}/${dataCount})
                )`
                : ''}
            </Typography>
            <DropDownForListing
              name={'ser'}
              value={ListSelection}
              onChange={(e) => {
                let value = e.target.value;
                setListSelection(value);
                setFilterColumns((prev) => ({
                  ...prev,
                  CancelFlag: value != 'All' ? (value == 'Active' ? 0 : 1) : '',
                }));
              }}
            />
            <div className="dropdown-list">
              <SimplePeriodDropdown
                value={{
                  from: filterColumns.EntryDateFrom || null,
                  to: filterColumns.EntryDateTo || null,
                }}
                onChange={(range) => {
                  setFilterColumns((prev) => ({
                    ...prev,
                    EntryDateFrom: range.from || '',
                    EntryDateTo: range.to || '',
                  }));
                }}
                title=""
                selectedWhenNull="year"
              />
            </div>

            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                border: '1px solid transparent',
                borderRadius: '5px',
                p: 1,
                cursor: 'pointer',
                '&:hover': {
                  borderColor: '#ccc',
                  backgroundColor: theme.palette.input.border || '#f5f5f5',
                },
              }}
              onClick={handleClickBox} // Toggle the popover on box click
            >
              <MoreVert sx={{ fontSize: '20px', color: '#fff' }} />

              <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
              >
                <Box sx={{ p: 1, minWidth: '200px' }}>
                  {options.map((option, index) =>
                    option.rollingOutSoon ? (
                      <Typography
                        key={index}
                        onClick={() => {
                          handleClose();
                        }}
                        sx={{
                          padding: '8px',
                          display: 'flex',
                          alignItems: 'center',
                          // '&:hover': {
                          //   backgroundColor: theme.palette.input.border || '#f5f5f5',
                          // },
                        }}
                      >
                        <Tooltip
                          title={<RollingSoon />}
                          placement="right"
                          PopperProps={{
                            sx: {
                              '& .MuiTooltip-tooltip': {
                                backgroundColor: 'transparent',
                                boxShadow: 'none',
                                padding: 0,
                              },
                            },
                          }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            {option.icon}
                            <span style={{ marginLeft: '8px', opacity: 0.5 }}>{option.label}</span>
                          </Box>
                        </Tooltip>
                      </Typography>
                    ) : (
                      <Link style={{ textDecoration: 'none', color: 'inherit' }} to={option.link} state={{ fromLink: '/customerList' }}>
                        <Typography
                          key={index}
                          onClick={() => {
                            handleClose();
                            option.onClick();
                          }}
                          sx={{
                            cursor: 'pointer',
                            padding: '8px',
                            display: 'flex',
                            alignItems: 'center',
                            // '&:hover': {
                            //   backgroundColor: theme.palette.input.border || '#f5f5f5',
                            // },
                          }}
                        >
                          {option.icon}
                          <span style={{ marginLeft: '8px' }}>{option.label}</span>
                        </Typography>
                      </Link>
                    )
                  )}
                </Box>
              </Popover>
            </Box>
          </Box>
        </Box>
      </Box>
      <>
        <Box
          sx={{
            // boxShadow: "inset 0 0 8px #d7d7d73b",
            boxShadow: 'rgb(33 35 38 / 10%) 0px 10px 10px -10px',
            borderBottomRightRadius: '12px',
            borderBottomLeftRadius: '12px',
            // backgroundColor: "transparent",
            // backgroundColor: theme.palette.bodyGray.secondary,
            // borderRadius:'12px',
            padding: {
              // xs: "8px 12px",
            },
            '.css-1mxz8qt-MuiPaper-root': {
              boxShadow: 'none',
            },
            '.MuiTableCell-root': {
              backgroundColor: 'transparent ',
              padding: '1px 10px',
              fontSize: '13px',
            },
            '.MuiTableCell-head': {
              backgroundColor: 'background.tablebg',
              padding: '5px 10px',
              borderBottom: '0px',
            },
          }}
        >
          {rows.length <= 0 && device ? (
            <Typography
              sx={{
                height: '70vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              No data found
            </Typography>
          ) : (
            <Box sx={{ width: '100%', overflow: 'hidden', boxShadow: 'none' }}>
              <TableContainer ref={tableRef} className="custom-scrollbar" sx={{ height: 'calc( 100vh - 240px )' }}>
                <Table
                  stickyHeader
                  aria-label="sticky table"
                  // sx={{ minWidth: 750 }}
                  aria-labelledby="tableTitle"
                  size={dense ? 'small' : 'medium'}
                >
                  <EnhancedTableHead
                    EnableSearch={EnableSearch}
                    setEnableSearch={setEnableSearch}
                    numSelected={selected.length}
                    order={order}
                    orderBy={orderBy}
                    getCompany={getCompany}
                    onSelectAllClick={handleSelectAllClick}
                    onRequestSort={handleRequestSort}
                    rowCount={dataCount}
                    onDelete={() => setDeleteSelectedModal(true)}
                    rowLength={rows.length}
                    setShowActions={setShowActions}
                    showActions={showActions}
                    scroll={scroll}
                  />
                  <TableBody ref={pusrchaseTableRef}>
                    <TableRow
                      sx={{
                        '.MuiTableCell-root': {
                          padding: '8px 15px',
                        },
                        '.css-wrnu0i-MuiInputBase-root': {
                          fontSize: '13px',
                        },
                        '.css-xk0adg-MuiButtonBase-root-MuiIconButton-root': {
                          padding: '2px 4px',
                        },
                        '.css-1gqfvv-MuiPaper-root': {
                          boxShadow: 'none',
                          borderBottom: 'solid 1px rgba(0,0,0,0.24)',
                          borderRadius: '0px',
                        },
                        // visibility: !EnableSearch ? "collapse" : "visible",
                        display: !EnableSearch ? 'none' : 'content',
                        // EnableSearch? { "display": "none"}:""
                      }}
                    >
                      {/* <TableCell></TableCell> */}
                      <TableCell>
                        <Paper
                          id="purchaseSearch"
                          sx={{
                            p: '2px 4px',
                            display: 'flex',
                            alignItems: 'center',
                            width: '100%',
                          }}
                        >
                          <DateRangeRsuite
                            ref={DateRangeRef}
                            containerRef={tableRef}
                            value={[
                              filterColumns.EntryDateFrom ? filterColumns.EntryDateFrom : null,
                              filterColumns.EntryDateTo ? filterColumns.EntryDateTo : null,
                            ]}
                            onChange={(e) => {
                              setFilterColumns((prev) => ({
                                ...prev,
                                EntryDateFrom: e.from ? e.from : '',
                                EntryDateTo: e.to ? e.to : '',
                              }));
                            }}
                            restrictToFinancialYear
                            className="hide-input-outline hide-input-border"
                          />
                          {/* <IconButton type="button" sx={{ p: '0px' }}>
                            {filterColumns.EntryDateFrom !== '' || filterColumns.EntryDateTo !== '' ? (
                              <Clear
                                fontSize="small"
                                onClick={() => {
                                  setFilterColumns((prev) => ({
                                    ...prev,
                                    EntryDateTo: '',
                                    EntryDateFrom: '',
                                  }));
                                }}
                              />
                            ) : (
                              <SearchIcon fontSize="small" />
                            )}
                          </IconButton> */}
                        </Paper>
                      </TableCell>
                      <TableCell>
                        <Paper
                          sx={{
                            p: '2px 4px',
                            display: 'flex',
                            alignItems: 'center',
                            width: '100%',
                          }}
                        >
                          <InputBase
                            name="VoucherNumber"
                            value={filterColumns.VoucherNumber}
                            onChange={(e) => handleFilterBySearch(e, 'VoucherNumber')}
                            sx={{ flex: 1 }}
                            placeholder="Search"
                            autoComplete="off"
                          />
                          <IconButton type="button" sx={{ p: '0px' }}>
                            {filterColumns.VoucherNumber !== '' ? (
                              <Clear
                                fontSize="small"
                                onClick={() => {
                                  setFilterColumns((prev) => ({
                                    ...prev,
                                    VoucherNumber: '',
                                  }));
                                }}
                              />
                            ) : (
                              <SearchIcon fontSize="small" />
                            )}
                          </IconButton>
                        </Paper>
                      </TableCell>

                      <TableCell>
                        <Paper
                          sx={{
                            p: '2px 4px',
                            display: 'flex',
                            alignItems: 'center',
                            width: '100%',
                          }}
                        >
                          <InputBase
                            name="SupplierID"
                            value={filterColumns.SupplierName}
                            onChange={(e) => handleFilterBySearch(e, 'SupplierName')}
                            sx={{ flex: 1 }}
                            placeholder="Search"
                            autoComplete="off"
                          />
                          <IconButton type="button" sx={{ p: '0px' }}>
                            {filterColumns.SupplierName !== '' ? (
                              <Clear
                                fontSize="small"
                                onClick={() => {
                                  setFilterColumns((prev) => ({
                                    ...prev,
                                    SupplierName: '',
                                  }));
                                }}
                              />
                            ) : (
                              <SearchIcon fontSize="small" />
                            )}
                          </IconButton>
                        </Paper>
                      </TableCell>
                      <TableCell>
                        <Paper
                          sx={{
                            p: '2px 4px',
                            display: 'flex',
                            alignItems: 'center',
                            width: '100%',
                          }}
                        >
                          <Autocomplete
                            id={''}
                            disableClearable
                            options={['UNPAID', 'PAID', 'PARTIAL']}
                            isOptionEqualToValue={(option, value) => option == value}
                            clearIcon={filterColumns.Status !== '' ? <ClearIcon style={{ fontSize: '20px' }} /> : null}
                            value={filterColumns.Status}
                            // onChange={onChange}
                            onChange={(e, value) => handleFilterBySearch(e, 'Status', value)}
                            size="small"
                            sx={{ height: '32px' }}
                            renderOption={(props, option) => (
                              <>
                                <MenuItem {...props} key={option} value={option}>
                                  <ListItemText primary={option} />
                                </MenuItem>
                              </>
                            )}
                            renderInput={(params) => (
                              <TextField
                                sx={{
                                  minWidth: '100px',
                                  border: 'none', // Ensure border is removed
                                  '& .MuiInput-underline:before': {
                                    borderBottom: 'none', // Remove underline in standard variant
                                  },
                                  '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
                                    borderBottom: 'none', // Remove hover effect
                                  },
                                  '& .MuiInput-underline:after': {
                                    borderBottom: 'none', // Remove underline for focused state
                                  },
                                  '& fieldset': { border: 'none' },
                                }}
                                placeholder={'Search'}
                                variant="standard"
                                InputLabelProps={{
                                  shrink: true,
                                  style: { color: 'black' },
                                }}
                                // onFocus={(e) => {
                                //   // When the input is focused, change the label to empty
                                //   e.target.placeholder = ""; // Remove placeholder text on focus if needed
                                // }}
                                // onBlur={(e) => {
                                //   // When the input loses focus, revert changes if necessary
                                //   e.target.placeholder = filterColumns.Status
                                //     ? ""
                                //     : "Search"; // Revert placeholder text on blur if needed
                                // }}
                                {...params}
                              />
                            )}
                          />
                          <IconButton type="button" sx={{ p: '0px' }}>
                            {filterColumns.Status !== '' ? (
                              <Clear
                                fontSize="small"
                                onClick={() => {
                                  setFilterColumns((prev) => ({
                                    ...prev,
                                    Status: '',
                                  }));
                                }}
                              />
                            ) : (
                              <SearchIcon fontSize="small" />
                            )}
                          </IconButton>
                        </Paper>
                      </TableCell>
                      <TableCell>
                        <Paper
                          sx={{
                            p: '2px 4px',
                            display: 'flex',
                            alignItems: 'center',
                            width: '100%',
                          }}
                        >
                          <DateRangeRsuite
                            containerRef={tableRef}
                            className="hide-input-outline hide-input-border"
                            value={[
                              filterColumns.DueDateFrom ? filterColumns.DueDateFrom : null,
                              filterColumns.DueDateTo ? filterColumns.DueDateTo : null,
                            ]}
                            onChange={(e) => {
                              setFilterColumns((prev) => ({
                                ...prev,
                                DueDateFrom: e.from ? e.from : '',
                                DueDateTo: e.to ? e.to : '',
                              }));
                            }}
                          />
                          {/* <IconButton type="button" sx={{ p: '0px' }}>
                            {filterColumns.DueDateFrom !== '' || filterColumns.DueDateTo != '' ? (
                              <Clear
                                fontSize="small"
                                onClick={() => {
                                  setFilterColumns((prev) => ({
                                    ...prev,
                                    DueDateFrom: '',
                                    DueDateTo: '',
                                  }));
                                }}
                              />
                            ) : (
                              <SearchIcon fontSize="small" />
                            )}
                          </IconButton> */}
                        </Paper>
                      </TableCell>
                      <TableCell>
                        <Paper
                          sx={{
                            p: '2px 4px',

                            width: '100%',
                          }}
                        >
                          <Stack direction={'row'} height={'32px'} gap="5px">
                            <MoneyTextFieldRange
                              value={[filterColumns.AmountFrom, filterColumns.AmountTo]}
                              onChange={(e) => {
                                handleFilterBySearch(e, 'GrandTotalAmount', e);
                              }}
                            />

                            <IconButton type="button" sx={{ p: '0px' }}>
                              {filterColumns.AmountFrom !== '' || filterColumns.AmountTo !== '' ? (
                                <Clear
                                  fontSize="small"
                                  onClick={() => {
                                    setFilterColumns((prev) => ({
                                      ...prev,
                                      AmountFrom: '',
                                      AmountTo: '',
                                    }));
                                  }}
                                />
                              ) : (
                                <SearchIcon fontSize="small" />
                              )}
                            </IconButton>
                          </Stack>
                        </Paper>
                      </TableCell>

                      <TableCell>
                        <Paper
                          sx={{
                            p: '2px 4px',

                            width: '100%',
                          }}
                        >
                          <Stack direction={'row'} height={'32px'} gap="5px">
                            <MoneyTextFieldRange
                              value={[filterColumns.balancedueamountfrom, filterColumns.balancedueamountto]}
                              onChange={(e) => {
                                handleFilterBySearch(e, 'BalanceDueAmount', e);
                              }}
                            />

                            <IconButton type="button" sx={{ p: '0px' }}>
                              {filterColumns.balancedueamountfrom !== '' || filterColumns.balancedueamountto !== '' ? (
                                <Clear
                                  fontSize="small"
                                  onClick={() => {
                                    setFilterColumns((prev) => ({
                                      ...prev,
                                      balancedueamountfrom: '',
                                      balancedueamountto: '',
                                    }));
                                  }}
                                />
                              ) : (
                                <SearchIcon fontSize="small" />
                              )}
                            </IconButton>
                          </Stack>
                        </Paper>
                      </TableCell>
                      {/* <TableCell>
                    <Paper
                      sx={{
                        p: "2px 4px",
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <InputBase
                        name="BalanceDueAmount"
                        value={filterColumns.BalanceDueAmount}
                        onChange={(e) =>
                          handleFilterBySearch(e, "BalanceDueAmount")
                        }
                        sx={{ flex: 1 }}
                        placeholder="Search"
                        autoComplete="off"
                      />
                      <IconButton type="button" sx={{ p: "0px" }}>
                        {filterColumns.BalanceDueAmount !== "" ? (
                          <Clear
                            fontSize="small"
                            onClick={() => {
                              setFilterColumns((prev) => ({
                                ...prev,
                                BalanceDueAmount: "",
                              }));
                              setFilteredList(rows);
                            }}
                          />
                        ) : (
                          <SearchIcon fontSize="small" />
                        )}
                      </IconButton>
                    </Paper>
                  </TableCell> */}

                      <TableCell>
                        <Paper
                          sx={{
                            p: '2px 4px',
                            display: 'flex',
                            alignItems: 'center',
                            width: '100%',
                          }}
                        >
                          <InputBase
                            name="overDueDays"
                            value={filterColumns.overDueDays}
                            onChange={(e) => handleFilterBySearch(e, 'overDueDays')}
                            sx={{ flex: 1 }}
                            placeholder="Search"
                            autoComplete="off"
                          />
                          <IconButton type="button" sx={{ p: '0px' }}>
                            {filterColumns.overDueDays !== '' ? (
                              <Clear
                                fontSize="small"
                                onClick={() => {
                                  setFilterColumns((prev) => ({
                                    ...prev,
                                    overDueDays: '',
                                  }));
                                }}
                              />
                            ) : (
                              <SearchIcon fontSize="small" />
                            )}
                          </IconButton>
                        </Paper>
                      </TableCell>

                      <TableCell>
                        <Paper
                          sx={{
                            p: '2px 4px',
                            display: 'flex',
                            alignItems: 'center',
                            width: '100%',
                          }}
                        >
                          <DateRangeRsuite
                            containerRef={tableRef}
                            value={[
                              filterColumns.SupplierInvoiceDateFrom ? filterColumns.SupplierInvoiceDateFrom : null,
                              filterColumns.SupplierInvoiceDateTo ? filterColumns.SupplierInvoiceDateTo : null,
                            ]}
                            onChange={(e) => {
                              setFilterColumns((prev) => ({
                                ...prev,
                                SupplierInvoiceDateFrom: e.from ? e.from : '',
                                SupplierInvoiceDateTo: e.to ? e.to : '',
                              }));
                            }}
                            className="hide-input-outline hide-input-border"
                          />
                        </Paper>
                      </TableCell>
                      <TableCell>
                        <Paper
                          sx={{
                            p: '2px 4px',
                            display: 'flex',
                            alignItems: 'center',
                            width: '100%',
                          }}
                        >
                          <InputBase
                            name="SupplierInvoiceNumber"
                            value={filterColumns.SupplierInvoiceNumber}
                            onChange={(e) => handleFilterBySearch(e, 'SupplierInvoiceNumber')}
                            sx={{ flex: 1 }}
                            placeholder="Search"
                            autoComplete="off"
                          />
                          <IconButton type="button" sx={{ p: '0px' }}>
                            {filterColumns.SupplierInvoiceNumber !== '' ? (
                              <Clear
                                fontSize="small"
                                onClick={() => {
                                  setFilterColumns((prev) => ({
                                    ...prev,
                                    SupplierInvoiceNumber: '',
                                  }));
                                }}
                              />
                            ) : (
                              <SearchIcon fontSize="small" />
                            )}
                          </IconButton>
                        </Paper>
                      </TableCell>
                      <TableCell className="actionBackGround" sx={{ backgroundColor: 'transparent !important' }}></TableCell>

                      {/* <TableCell>
                                    <Paper
                                        sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: '100%' }}
                                    >
                                        <InputBase
                                        sx={{ flex: 1 }}
                                        placeholder="Search"
                                        />
                                        <IconButton type="button" sx={{ p: '0px' }}>
                                        <SearchIcon fontSize='small' />
                                        </IconButton>
                                    </Paper>
                                </TableCell> */}
                      {/* <TableCell></TableCell> */}
                    </TableRow>
                    {/* if you don't need to support IE11, you can replace the `stableSort` call with:
                            rows.slice().sort(getComparator(order, orderBy)) */}

                    {console.log(rows, 'PPPPPP')}
                    {rows.length > 0 ? (
                      rows
                        .slice(page * rowsPerPageRef.current, page * rowsPerPageRef.current + rowsPerPageRef.current)
                        .map((row, index) => {
                          const isItemSelected = isSelected(row.purchaseid);
                          const labelId = `enhanced-table-checkbox-${index}`;
                          let status = row.statuscd;
                          const title = row.cancelflag === 1 ? 'Cancelled' : '';
                          switch (row.statuscd) {
                            case 'Paid':
                              status = (
                                <Typography
                                  sx={{
                                    color: row.cancelflag === 1 ? 'gray' : '#009933',
                                    opacity: row.cancelflag === 1 ? 0.5 : 1,
                                    fontSize: '13px',
                                    display: 'flex',
                                    alignItems: 'center',
                                  }}
                                >
                                  <CheckCircleIcon
                                    sx={{
                                      fontSize: '15px',
                                      marginRight: '5px',
                                    }}
                                  />{' '}
                                  {row.statuscd}
                                </Typography>
                              );
                              break;
                            case 'UnPaid':
                              status = (
                                <Typography
                                  sx={{
                                    color: row.cancelflag === 1 ? 'gray' : '#eb4141',
                                    opacity: row.cancelflag === 1 ? 0.5 : 1,
                                    fontSize: '13px',
                                    display: 'flex',
                                    alignItems: 'center',
                                  }}
                                >
                                  <ErrorIcon
                                    sx={{
                                      fontSize: '15px',
                                      marginRight: '5px',
                                    }}
                                  />{' '}
                                  {row.statuscd}
                                </Typography>
                              );
                              break;
                            case 'Partial':
                              status = (
                                <Typography
                                  sx={{
                                    color: row.cancelflag === 1 ? 'gray' : '#6096d9',
                                    opacity: row.cancelflag === 1 ? 0.5 : 1,
                                    fontSize: '13px',
                                    display: 'flex',
                                    alignItems: 'center',
                                  }}
                                >
                                  <RunningWithErrorsIcon
                                    sx={{
                                      fontSize: '15px',
                                      marginRight: '5px',
                                    }}
                                  />{' '}
                                  {row.statuscd}
                                </Typography>
                              );
                              break;

                            default:
                              break;
                          }
                          let currencySymbol = '₹'; //billingCurrencyOptions.find((elem) => row.CurrencyCode == elem.value)?.sign
                          const ewayDat = new Date(row?.ewaybillenteredtimestamp * 1000);
                          const dayjsEwayDat = dayjs(ewayDat);
                          const currentDate = dayjs(); // This keeps the time part as well!
                          const diffEway = currentDate.diff(dayjsEwayDat, 'hour', true);
                          return (
                            <>
                              <TableRow
                                className={row.cancelflag === 1 ? 'rowInactiveMuted' : ''}
                                hover
                                // onClick={(event) => handleClick(event, row.VoucherNumber)}
                                role="checkbox"
                                aria-checked={isItemSelected}
                                tabIndex={-1}
                                key={index}
                                selected={isItemSelected}
                                onClick={() => handleRowClick(row)}
                                style={{ cursor: 'pointer' }}
                                sx={{
                                  '.MuiTableCell-root': {
                                    backgroundColor: 'transparent ',
                                    borderBottom: 'none',
                                  },
                                }}
                              >
                                {/* <TableCellWithToolTip
                              row={row}
                              padding="checkbox"
                              sx={{
                                ".css-1mqsplk-MuiButtonBase-root-MuiCheckbox-root":
                                {
                                  padding: "5px",
                                },
                              }}
                            >
                              <Checkbox
                                color="primary"
                                onClick={(event) => {
                                  event.stopPropagation();
                                  handleClick(event, row.PurchaseID);
                                }}
                                checked={selected.indexOf(row.PurchaseID) >= 0}
                                inputProps={{
                                  "aria-labelledby": labelId,
                                }}
                                size="small"
                              />
                            </TableCellWithToolTip> */}
                                <TableCell
                                  row={row}
                                  sx={{
                                    color: row.cancelflag === 1 ? 'input.label' : '',
                                  }}
                                  // component="th"
                                  id={labelId}
                                  scope="row"
                                  title={title}
                                  // padding="none"
                                >
                                  {formatUnixTimestamp(row.entrydate)}
                                </TableCell>
                                {/* <TableCellWithToolTip align="left" row={row}>
                                  <MUILink
                                    underline="hover"
                                    sx={{ cursor: "pointer" }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      dispatch(
                                        updateViewTitle(
                                          row.cancelflag == 1
                                            ? {
                                                type: "Cancelled",
                                                name: row.vouchernumber,
                                              }
                                            : {
                                                type: "",
                                                name: row.vouchernumber,
                                              }
                                        )
                                      );
                                      if (
                                        row.purchasegsttypecd === "NONTAXABLE"
                                      ) {
                                        navigate(
                                          "/viewpurchaseandexpensenontaxable",
                                          {
                                            state: {
                                              id: row.purchaseid,
                                              view: true,
                                            },
                                          }
                                        );
                                      } else {
                                        navigate("/viewnewpurchasetax", {
                                          state: {
                                            id: row.purchaseid,
                                            view: true,
                                          },
                                        });
                                      }
                                    }}
                                  >
                                    <Typography
                                      sx={{
                                        fontSize: "13px",
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      {" "}
                                      <Typography>
                                        {row.vouchernumber}{" "}
                                      </Typography>
                                      {row.cancelflag === 1 && (
                                        <Typography
                                          sx={{
                                            color: "danger.main",
                                            marginLeft: "5px",
                                          }}
                                        ></Typography>
                                      )}
                                    </Typography>
                                  </MUILink>
                                </TableCellWithToolTip> */}
                                <TableCell align="left" title={title}>
                                  <a
                                    className="myLink"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                    }}
                                    href={`/viewnewpurchasetax/${row.vouchernumber}?transaction=${row.purchaseid}`}
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    {row.vouchernumber}
                                  </a>
                                </TableCell>
                                <TableCell
                                  align="left"
                                  row={row}
                                  title={title}
                                  onClick={(e) => {
                                    // e.stopPropagation();
                                    e.preventDefault();
                                    // navigate("/viewsupplier", {
                                    //   state: {
                                    //     id: row.SupplierID,
                                    //     view: true,
                                    //   },
                                    // });
                                  }}
                                  sx={{
                                    maxWidth: '100px',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                  }}
                                >
                                  {/* <Link
                                underline="hover"
                                style={{
                                  color: theme.palette.text.Link,
                                  cursor: "pointer",
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  e.preventDefault();
                                  const state = { id: row.customerOrSupplierID, view: true };
                                  localStorage.setItem("customerState", JSON.stringify(state));
                                  navigate("/viewsupplier", {
                                    state: {
                                      id: row.SupplierID,
                                      view: true,
                                    },
                                  });
                                }}
                              > */}{' '}
                                  <Tooltip title={row?.partydisplayname} placement="right">
                                    <span
                                      style={{
                                        display: 'block',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                      }}
                                    >
                                      <a
                                        className="myLink"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                        }}
                                        href={`/viewsupplier?id=${row.supplierid}&view=true&title=${row?.partydisplayname}`}
                                        target="_blank"
                                      >
                                        {row?.partydisplayname}
                                      </a>
                                    </span>
                                  </Tooltip>
                                  {/* </Link> */}
                                </TableCell>
                                <TableCell
                                  row={row}
                                  title={title}
                                  align="left"
                                  sx={{
                                    fontSize: '13px',
                                  }}
                                >
                                  {status}
                                </TableCell>
                                <TableCell align="left" title={title} sx={{ whiteSpace: 'nowrap' }}>
                                  {row.dueDate}
                                </TableCell>
                                <TableCell align="right" row={row} title={title} sx={{ whiteSpace: 'nowrap' }}>
                                  <a
                                    underline="hover"
                                    style={{
                                      color: theme.palette.text.Link,
                                      cursor: 'pointer',
                                    }}
                                    href={`/LedgerTransactions/${row?.partyaccountid}`}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      e.preventDefault();
                                      if (row?.partyaccountid !== '') {
                                        // setBackdropOpen(true);
                                        // setAccountName(row?.PartyDisplayName);
                                        setAccountID(row?.partyaccountid);
                                        // getModalData(row?.PartyAccountID);
                                      }
                                    }}
                                  >
                                    {currencySymbol} {MoneyFormatv3(row.granttotalamount, 'en-IN')}
                                  </a>
                                </TableCell>

                                <TableCell align="right" row={row} title={title}>
                                  <a
                                    underline="hover"
                                    style={{
                                      color: theme.palette.text.Link,
                                      cursor: 'pointer',
                                    }}
                                    // href={`/LedgerTransactions/${row?.partyaccountid}`}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      e.preventDefault();
                                      if (row?.partyaccountid !== '') {
                                        // setBackdropOpen(true);
                                        // setAccountName(row?.PartyDisplayName);
                                        setAccountID(row?.partyaccountid);
                                        // getModalData(row?.PartyAccountID);
                                      }
                                    }}
                                  >
                                    {currencySymbol} {MoneyFormatv3(row.balancedueamount, 'en-IN')}
                                  </a>
                                </TableCell>
                                {/* <TableCellWithToolTip align="right" row={row}>
                                 <Box sx={{ minWidth: "150px" }}>
                                  {row.statuscd === "Paid"
                                    ? 0 
                                    : (
                                        <span >
                                          {(() => {
                                            const diff = overDue(row.dueDate);
                                            return diff < 0 ? <span style={{color:"red"}}>{diff} </span> : <span style={{color:"green"}}> {diff} </span>
                                          })()}
                                        </span>
                                      )}
                                  </Box>
                                </TableCellWithToolTip > */}
                                {console.log(row, 'row')}
                                <TableCell align="right" row={row} title={title}>
                                  {row.statuscd === 'Paid' ? (
                                    '-'
                                  ) : (
                                    <span
                                      style={{
                                        color: row.cancelflag === 1 ? 'gray' : row.overduedays < 0 ? 'red' : 'green',
                                        opacity: row.cancelflag === 1 ? 0.5 : 1,
                                      }}
                                    >
                                      {Math.abs(row.overduedays)}&nbsp;
                                      {row.statuscd === 'Paid' ? '' : Math.abs(row.overduedays) == 1 ? 'day' : 'days'}
                                    </span>
                                  )}
                                </TableCell>

                                {getCompany?.relatedcompanydetailsnew?.[0]?.ewaybillflag == 1 ? (
                                  <TableCell
                                    sx={{ width: '100px', padding: '0px!important' }}
                                    title={row.cancelflag === 1 ? 'Cancelled' : ''}
                                  >
                                    {row.goods_exist === 0 ? (
                                      <Typography align="center" sx={{ fontSize: '13px' }}>
                                        N/A
                                      </Typography>
                                    ) : !row?.ewaybillno && row.cancelflag !== 1 ? (
                                      <Button
                                        variant="outlined"
                                        sx={{
                                          whiteSpace: 'nowrap',
                                          // padding: '2px 8px',
                                          fontSize: '13px',
                                        }}
                                        onClick={(e) => {
                                          handleEWaybill(e, row);
                                          setActionData(row);
                                        }}
                                      >
                                        Generate
                                      </Button>
                                    ) : row.ewaybillno && !row?.ewaybill_is_cancelled && diffEway < 24 ? (
                                      <Stack direction="row" alignItems="center" spacing={1}>
                                        {' '}
                                        <Button
                                          variant="outlined"
                                          sx={{
                                            whiteSpace: 'nowrap',
                                            paddingLeft: '8px',
                                            paddingRight: '8px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            lineHeight: 1.2,
                                          }}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleCancelEWay(row);
                                          }}
                                        >
                                          <Box sx={{ fontSize: '12px' }}> Cancel EWB</Box>
                                          <Box sx={{ color: 'red', fontSize: '8px' }}>
                                            <TimeLeftComp startUnix={row?.ewaybillenteredtimestamp} />
                                          </Box>
                                        </Button>
                                      </Stack>
                                    ) : row?.ewaybill_is_cancelled === 1 ? (
                                      <Box
                                        variant="inherit"
                                        sx={{
                                          color: row.cancelflag === 1 && 'gray',
                                          opacity: row.cancelflag === 1 ? 0.5 : 1,
                                          padding: '2px 8px',
                                          fontSize: '13px',
                                          textAlign: 'center',
                                        }}
                                      >
                                        Cancelled
                                      </Box>
                                    ) : !row?.ewaybill_is_cancelled ? (
                                      <Typography
                                        align="center"
                                        sx={{
                                          color: row.cancelflag === 1 ? 'gray' : row.ewaybillstatus === 'Active' && 'green',
                                          fontSize: '13px',
                                        }}
                                      >
                                        {row.ewaybillstatus}
                                      </Typography>
                                    ) : null}
                                  </TableCell>
                                ) : null}

                                {getCompany?.relatedcompanydetailsnew?.[0]?.ewaybillflag == 1 ? (
                                  <TableCell
                                    sx={{
                                      width: '100px',
                                      padding: '0px!important',
                                    }}
                                    title={row.cancelflag === 1 ? 'Cancelled' : ''}
                                  >
                                    {row.ewaybillno && (
                                      <Tooltip title={'Download PDF'} placement="left" disableInteractive arrow>
                                        <IconButton
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            e.preventDefault();
                                            checkandopenpdf(row.ewaybillpdf);
                                          }}
                                          aria-label="delete"
                                          sx={{
                                            margin: '0px 2px',
                                            padding: '5px',
                                            backgroundColor: '#c5d6dc',
                                            border: 'solid 1px black',
                                          }}
                                        >
                                          <img src={pdfImage} height={10} alt="Download" />
                                        </IconButton>
                                      </Tooltip>
                                    )}
                                  </TableCell>
                                ) : null}
                                {/* {getCompany?.relatedcompanydetailsnew?.[0]?.ewaybillflag == 1 ? (
                                  <TableCell sx={{ width: '100px', padding: '2px 8px' }} title={row.cancelflag === 1 ? 'Cancelled' : ''}>
                                    <Box variant="inherit">{row?.ewaybillstatus}</Box>
                                  </TableCell>
                                ) : null} */}

                                <TableCell align="left" title={title}>
                                  {row.supplierinvoicedate === 0 ? '' : formatUnixTimestamp(row.supplierinvoicedate)}
                                </TableCell>
                                <TableCell align="right" title={title}>
                                  {row.supplierinvoicenumber == 0 ? '' : row.supplierinvoicenumber}
                                </TableCell>

                                {/* <TableCellWithToolTip align="left" row={row}>
                            <a
                              underline="hover"
                              style={{ color: theme.palette.text.Link,  cursor: "pointer" }}
                              href={`/viewLedger?id=${row?.AccountsID}&&name=${row?.PartyDisplayName}&&page=/allpurchaseandexpense`}
                              onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                if (
                                  row?.RelatedPartyMaster?.[0].AccountsID !== ""
                                ) {
                                  setBackdropOpen(true);
                                  setAccountName(
                                    row?.PartyDisplayName
                                  );
                                  setAccountID(
                                    row?.SupplierID
                                  );
                                  getModalData(
                                    row?.SupplierID
                                  );
                                }
                              }}
                            >
                              {" "}
                              {MoneyFormat(row.BalanceDueAmount, "en-IN")}
                            </a>
                          </TableCellWithToolTip> */}

                                <TableCell
                                  align="center"
                                  className="actionBackGround"
                                  onMouseEnter={() => setdisableToolTip(true)}
                                  onMouseLeave={() => setdisableToolTip(false)}
                                  sx={{ position: !showActions ? 'relative' : 'sticky' }}
                                >
                                  <Box className="actionCellStyle">
                                    <Tooltip title={'Download PDF'} placement="left" disableInteractive arrow>
                                      <IconButton
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          e.preventDefault();
                                          checkandopenpdf(row.purchaseinvoicepdf);
                                        }}
                                        aria-label="delete"
                                        sx={{
                                          margin: '0px 2px',
                                          padding: '5px',
                                          backgroundColor: '#c5d6dc',
                                          border: 'solid 1px black',
                                        }}
                                      >
                                        <img src={pdfImage} height={10} alt="Download" />
                                      </IconButton>
                                    </Tooltip>
                                    <Tooltip title={'Print'} placement="left" disableInteractive arrow>
                                      <IconButton
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          fetchAndPrintPDF(row.purchaseinvoicepdf);
                                        }}
                                        aria-label="delete"
                                        sx={{
                                          margin: '0px 2px',
                                          padding: '5px',
                                          backgroundColor: '#c5d6dc',
                                          border: 'solid 1px black',
                                        }}
                                      >
                                        <Print
                                          sx={{
                                            fontSize: '10px',
                                            color: '#36454f',
                                          }}
                                        />
                                      </IconButton>
                                    </Tooltip>
                                    {/* {row.expiredtimestamp === 0 && row.cancelflag == 0 ? ( */}
                                    <Tooltip
                                      title={row.cancelflag == 0 ? 'Edit' : 'cannot Edit'}
                                      placement="right"
                                      disableInteractive
                                      arrow
                                    >
                                      <IconButton
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          if (Freeze == 1) {
                                            return handleFreeze();
                                          }
                                          if (row.expiredtimestamp === 0 && row.cancelflag == 1) {
                                            return;
                                          }
                                          dispatch(updateTitle(row.vouchernumber));
                                          if (row.purchasegsttypecd === 'NONTAXABLE') {
                                            // localStorage.removeItem(
                                            //   "PurchaseIDNonTaxable"
                                            // );
                                            // localStorage.removeItem("ViewMode");
                                            navigate('/editnewpurchasetax', {
                                              state: {
                                                id: row.purchaseid,
                                                pdflink: row.purchaseinvoicepdf,
                                              },
                                            });
                                          } else {
                                            // localStorage.removeItem(
                                            //   "PurchaseIDTaxable"
                                            // );
                                            navigate('/editnewpurchasetax', {
                                              state: {
                                                id: row.purchaseid,
                                                pdflink: row.purchaseinvoicepdf,
                                              },
                                            });
                                          }
                                        }}
                                        aria-label="delete"
                                        sx={{
                                          margin: '0px 2px',
                                          padding: '5px',
                                          backgroundColor: '#D0EFFF',
                                          border: 'solid 1px black',
                                        }}
                                      >
                                        {row.expiredtimestamp === 0 && row.cancelflag == 0 ? (
                                          <Edit
                                            sx={{
                                              fontSize: '10px',
                                              color: '#6096d9',
                                            }}
                                          />
                                        ) : (
                                          <EditOff sx={{ fontSize: '10px', color: '#6096d9' }} />
                                        )}
                                      </IconButton>
                                    </Tooltip>
                                    {/* ) : null} */}
                                    <Tooltip title={'Share'} placement="left" disableInteractive arrow>
                                      <IconButton
                                        onClick={(e) => {
                                          e.preventDefault();
                                          e.stopPropagation();
                                          // For individual Share, use separate state
                                          // that doesn't interfere with bulk selection
                                          setIndividualEmailSelection([
                                            {
                                              PartyID: row?.supplierid,
                                              Email: row?.partyemail,
                                              PartyDisplayName: row?.partydisplayname,
                                              invoiceid: row.purchaseid,
                                              invoicenumber: row?.vouchernumber,
                                            },
                                          ]);
                                          setShareOpen(row?.purchaseinvoicepdf, true);
                                        }}
                                        aria-label="delete"
                                        sx={{
                                          margin: '0px 2px',
                                          padding: '5px',
                                          backgroundColor: '#E8F5E9',
                                          border: 'solid 1px black',
                                          // backgroundColor: '#b1d1f97d'
                                        }}
                                      >
                                        <Share
                                          sx={{
                                            fontSize: '10px',
                                            color: '#388E3C',
                                            // color: '#6096d9'
                                          }}
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  </Box>
                                </TableCell>
                                <TableCell align="left" row={row} title={title}>
                                  <Box
                                    sx={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      alignItems: 'center',
                                      minWidth: '150px',
                                    }}
                                  >
                                    {row.cancelflag !== 1 && row.statuscd !== 'Paid' && (
                                      <Button
                                        disabled={row.paymentclearedflag === 1 && row.statuscd !== 'Partial' ? true : false}
                                        variant="contained"
                                        size="small"
                                        sx={{
                                          fontSize: '10px',
                                          boxShadow: '0px 6px 8px rgba(0, 0, 0, 0.5)',
                                        }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          if (Freeze == 1) {
                                            return handleFreeze();
                                          }
                                          console.log({ row });
                                          // listPartyAccountDetails(
                                          //   row?.RelatedPartyMaster?.[0]
                                          //     .PartyDisplayName,
                                          //   row.PurchaseID
                                          // );
                                          navigate('/addpaymententries', {
                                            state: {
                                              name: row?.partydisplayname,
                                              partyID: row.partyaccountid,
                                              invoiceNumber: row.vouchernumber,
                                            },
                                          });
                                        }}
                                      >
                                        RECORD PAYMENT
                                      </Button>
                                    )}
                                  </Box>
                                </TableCell>
                                {isLocal && (
                                  <TableCell>
                                    <button
                                      onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        generatePDF(row.vouchernumber, row.purchaseid);
                                      }}
                                    >
                                      gen
                                    </button>
                                  </TableCell>
                                )}
                              </TableRow>
                            </>
                          );
                        })
                    ) : circularOpen == false && rows.length <= 0 && !dataCount > 0 ? (
                      <TableRow>
                        <TableCell height={400} align="center" colSpan={12} sx={{ border: 'none' }}>
                          No Data Found
                        </TableCell>
                      </TableRow>
                    ) : (
                      ''
                    )}
                    {/* {filteredList.length === 0 && !circularOpen && (
                  <TableRow
                    style={{
                      height: (dense ? 33 : 53) * emptyRows,
                    }}
                  >
                    <TableCell colSpan={12} />
                  </TableRow>
                )} */}
                    {circularOpen == true &&
                      limit > 0 &&
                      Array.from({ length: limit }, (_, index) => (
                        <TableRow key={index}>
                          <TableCell colSpan={12}>
                            <Skeleton variant="text" sx={{ fontSize: '2rem' }} />
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
              {/* <Fade
            in={circularOpen}
            style={{
              transitionDelay: circularOpen ? "800ms" : "0ms",
            }}
            unmountOnExit
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                margin: "20px 0px",
              }}
            >
              <CircularProgress />
            </Box>
          </Fade> */}
              {dataCount > 0 && (
                <TablePagination
                  // rowsPerPageOptions={[5, 10, 25,{ label: 'All', value: -1 }]}
                  rowsPerPageOptions={defaultRowsPerPageOptions}
                  component="div"
                  count={dataCount}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              )}
            </Box>
          )}

          <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={backdropOpen}>
            <CircularProgress color="inherit" />
          </Backdrop>
          {shareOpen ? (
            <ShareModal
              open={shareOpen}
              emailData={{
                selectedRow: individualEmailSelection?.map((inv) => ({
                  id: Number(inv.invoiceid),
                  recipientId: Number(inv.PartyID),
                  email: inv.Email,
                  name: inv.PartyDisplayName,
                  invoiceNumber: inv.invoicenumber,
                })),
                type: 'purchaseInvoice',
              }}
              setOpen={setShareOpen}
            />
          ) : null}
          {/* <ExportData
          setOpen={setExportModalOpen}
          open={exportModalOpen}
          item={exportItem}
        /> */}
        </Box>
      </>
      {accountID && <LedgerTransactionModalv2 open={accountID} accountId={accountID} onClose={() => setAccountID('')} />}

      {WarningModal}
      <EInvAuth
        //  open={cancelEOpen} setOpen={setCancelEOpen} allSales={true} setCancelEInv={setCancelEInv}
        open={cancelEOpen}
        checkbox={connectCheckbox}
        setOpen={setCancelEOpen}
        allSales={false}
        action={() => {
          console.log(connectCheckbox, 'connectCheckbox');
          if (action === 'geneway') {
            ewayNav(actionData);
          } else if (connectCheckbox.includes('eway')) {
            setCancelEInv(true);
          }
        }}
        setCancelEInv={setCancelEInv}
        rowData={rowData}
      />
      {cancelEInv ? (
        <EInvoiceCancel
          state={cancelEInvState}
          setState={setCancelEInvState}
          open={cancelEInv}
          handleEINVBlur={handleEINVBlur}
          backdropOpen={backdropOpen}
          handleInputChange={handleInputChange}
          setOpen={setCancelEInv}
          itemData={rowData}
          cancelEINV={handleCancelEWaybill}
        />
      ) : null}
      <SendEmailModalWrapper {...modalProps} />
    </Box>
  );
}

export default AllPurchaseandExpense;
